import React, { useEffect, useState } from 'react';
import { Card, CardBody } from 'reactstrap';
import { PageTitle, Button, Table } from '@cordata/buffet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useHistory } from 'react-router-dom';
import Select from 'react-select';

import { adminInstance as axiosAdmin } from '~/utils';

import useSlice from '~/utils/slice/hook';

const ScheduledReports = () => {
  const history = useHistory();
  const { fetch } = useSlice();

  const [availableOrganizations, setAvailableOrganizations] = useState([]);
  const [availableDivisions, setAvailableDivisions] = useState([]);

  const [selectedOrganization, setSelectedOrganization] = useState();

  const [existingScheduledReports, setExistingScheduledReports] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetch('organization')
      .then(r => r.data.data)
      .then((r) => {
        setIsLoading(false);
        setAvailableOrganizations(r);

        if (localStorage.getItem('org')) {
          setSelectedOrganization(r.find(rr => rr.id === localStorage.getItem('org')));
        }
      });
  }, []);

  useEffect(() => {
    if (selectedOrganization) {
      localStorage.setItem('org', selectedOrganization.id);

      axiosAdmin
        .get(`/scheduled-report?org-uid=${selectedOrganization.id}&all-data=1`)
        .then(r => r.data.data)
        .then(r => setExistingScheduledReports(r))
        .then(() => setIsLoading(false));

      fetch('division', {
        'org-uid': selectedOrganization.id,
      })
        .then(r => r.data.data)
        .then(setAvailableDivisions);
    }
  }, [selectedOrganization]);

  const tableColumns = [{
    id: 'division',
    Header: 'Division',
    accessor: (item) => {
      const division = availableDivisions.find(d => item.attributes.divisionUid === d.id);
      return division ? division.attributes.divisionName : '';
    },
  }, {
    id: 'reportLabel',
    Header: 'Report Label',
    accessor: 'attributes.scheduledReportLabel',
  }, {
    id: 'className',
    Header: 'Class Name',
    accessor: 'attributes.className',
  }, {
    id: 'frequency',
    Header: 'Frequency',
    accessor: 'attributes.frequency',
  }, {
    id: 'userMode',
    Header: 'User Mode',
    accessor: item => {
      if (item.attributes.userClassName === 'ReportUserOptOutService') return 'Opt Out';
      if (item.attributes.userClassName === 'ReportUserOptInService') return 'Opt In';
      return undefined;
    },
  }, {
    id: 'delete',
    Header: 'Deactivate',
    accessor: () => 'Click here to deactivate',
    filterable: false,
  }];

  const refreshReportList = () => {
    if (selectedOrganization) {
      axiosAdmin
        .get(`/scheduled-report?org-uid=${selectedOrganization.id}`)
        .then(r => r.data.data)
        .then(setExistingScheduledReports);
    }
  };

  const deleteScheduledReport = (item) => {
    axiosAdmin
      .delete(`/scheduled-report/${item.id}`)
      .then(refreshReportList);
  };

  return (
    <>
      <PageTitle
        action={
          <Button
            outline
            tag={Link}
            to="/organization/scheduled-reports/add"
          >
            <FontAwesomeIcon icon="plus" />
            <span className="d-none d-md-inline ml-2">Add Scheduled Report</span>
          </Button>
          }
      >
        Scheduled Reports
      </PageTitle>

      <Card>
        <form noValidate>
          <CardBody>
            <Select
              isClearable
              id="org"
              options={availableOrganizations}
              value={selectedOrganization}
              onChange={setSelectedOrganization}
              placeholder="Select your organization"
              className="form-select mb-3"
              classNamePrefix="react-select"
              getOptionValue={o => o.id}
              getOptionLabel={o => o.attributes.orgName}
              isLoading={isLoading}
            />

            {selectedOrganization && (
              <Table
                data={existingScheduledReports}
                columns={tableColumns}
                defaultSorted={[{ id: 'division' }]}
                filterable
                defaultFilterMethod={(filter, row) =>
                  row[filter.id].toLowerCase().includes(filter.value.toLowerCase())
                }
                getTdProps={(state, rowInfo, column) => ({
                  onClick: () => {
                    if (column.id === 'delete') {
                      deleteScheduledReport(rowInfo.original);
                    } else {
                      history.push(`/organization/scheduled-reports/${rowInfo.original.id}`);
                    }
                  },
                })}
              />
            )}
          </CardBody>
        </form>
      </Card>
    </>
  );
};

export default ScheduledReports;
